// extracted by mini-css-extract-plugin
module.exports = {"header":"TheHeader_header_3Of4R","avatar":"TheHeader_avatar_1SExE"};